/** @format */

const template = `
<ng-form name="{{::ctrl.formName}}">
  <div ng-if="ctrl.validityPeriodDisabled()" class="form-group-mimic">
    <span translate>SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.VALID_THROUGH_THE_WHOLE_PERIOD</span>
  </div>
  <div class="grouping-panel-content">
    <div class="form-group" ng-if="!ctrl.validityPeriodDisabled()">
      <div class="row">
        <div class="col-12">
          <local-date-range-editor
            name="validityPeriod{{ $index }}"
            start-date-required="{{ ctrl.startDateRequired }}"
            end-date-required="{{ ctrl.endDateRequired }}"
            start-date-disabled="{{ ctrl.startDateDisabled }}"
            start-date-disabled-message="SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.START_DATE_DISABLED_FOR_FIRST_ITEM"
            end-date-disabled="{{ ctrl.endDateDisabled }}"
            end-date-disabled-message="SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.END_DATE_DISABLED_FOR_LAST_ITEM"
            ng-change="ctrl.dateChanged()"
            ng-model="ctrl.validityPeriod">
          </local-date-range-editor>
        </div>
      </div>
    </div>
    <div class="row organisation-row" ng-repeat="organisationRoleShare in ctrl.organisationRoleShares">
      <div
        class="col-12 form-group"
        ng-class="{ 'col-md-8': !ctrl.isCoordinatingOrganisationUrn(), 'col-md-4': ctrl.isCoordinatingOrganisationUrn() }">
        <label ng-class="{ 'd-md-none': $index !== 0 }" translate
          >SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.ORGANISATION</label
        >
        <search-organisation
          organisation="organisationRoleShare.organisation"
          organisation-service="ctrl.organisationService"
          disabled-organisation-ids="ctrl.disabledOrganisationIds"
          on-select="ctrl.organisationSelected(organisationRoleShare, orgObj)">
        </search-organisation>
      </div>

      <div class="col-12 col-md-4 form-group" ng-if="ctrl.isCoordinatingOrganisationUrn()">
        <label ng-class="{ 'd-md-none': $index !== 0 }" translate
          >SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.EDUCATIONAL_INSTITUTION</label
        >
        <sis-code-select-editor
          name="educationalInstitutionUrn"
          [codebook-urn]="'urn:code:educational-institution'"
          [selected-urn]="organisationRoleShare.educationalInstitutionUrn"
          (on-select-code)="
            organisationRoleShare.educationalInstitutionUrn = $event.selectedUrn; ctrl.handleChange()
          "></sis-code-select-editor>
      </div>

      <div class="col-6 col-md-2 form-group">
        <label ng-class="{ 'd-md-none': $index !== 0 }" translate
          >SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.PERCENTAGE</label
        >
        <percent-editor ng-model="organisationRoleShare.share" ng-change="ctrl.shareChanged(organisationRoleShare)"> </percent-editor>
      </div>

      <div class="col-2 button-col" ng-class="{ first: $first }">
        <button
          type="button"
          class="btn btn-primary btn-naked btn-lg form-control btn-just-icon"
          title="{{::'SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.REMOVE' |translate}}"
          ng-click="ctrl.remove(organisationRoleShare)"
          aria-label="{{::'SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.REMOVE' |translate}}">
          <sis-icon icon="delete"></sis-icon
        ></button>
      </div>
    </div>

    <div class="row add-new">
      <div class="col-md-12">
        <button type="button" class="link-button" ng-click="ctrl.addNew()" data-cy="add-organisation-role-share">
          <sis-icon icon="ring-plus"></sis-icon>{{ ctrl.addOrganisationOrEducationalInstitutionTranslationKey() | translate }}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-12">
        <ul class="error-list" role="alert">
          <li ng-if="ctrl.validateSumOfSharesNotEqualToHundred()" translate
            >SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.SUM_OF_SHARES_MUST_EQUAL_HUNDRED</li
          >
          <li ng-if="ctrl.validateHasDuplicates()" translate
            >SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.HAS_DUPLICATE_ORGANISATIONS</li
          >
          <li ng-if="ctrl.validateItemsWithoutOrganisationId()" translate
            >SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.ORGANISATION_MISSING</li
          >
          <li ng-if="ctrl.validateItemsWithoutShare()" translate
            >SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.SHARE_MISSING</li
          >
          <li ng-if="ctrl.validateHasGapBetweenValidityGroups()" translate
            >SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.NO_GAPS_BETWEEN_VALIDITY_GROUPS</li
          >
          <li ng-if="ctrl.validateHasOverlappingValidityGroups()" translate
            >SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.NO_OVERLAPPING_VALIDITY_GROUPS</li
          >
          <li ng-if="ctrl.validateItemsWithoutStartDate()" translate
            >SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.START_DATE_MISSING</li
          >
          <li ng-if="ctrl.validateItemsWithoutEndDate()" translate
            >SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.END_DATE_MISSING</li
          >
          <li ng-if="ctrl.validateItemsWithOrganisationIdAndEducationalInstitutionUrn()" translate
            >SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.ONLY_ORGANISATION_OR_EDUCATIONAL_INSTITUTION</li
          >
          <li ng-if="ctrl.validateItemsWithoutOrganisationIdAndEducationalInstitutionUrn()" translate
            >SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.ORGANISATION_AND_EDUCATIONAL_INSTITUTION_MISSING</li
          >
        </ul>
      </div>
    </div>
  </div>
</ng-form>
`;
export default template;
